import { color } from "@/styles/tokens";
import type { _SVGIcon } from "hsl-core/Components";

export const STROKE = color.border.ctaSecondary;

const body: _SVGIcon.IconBody = (params) => {
	const stroke = params?.stroke ?? STROKE;
	return `
   <path d="M8.4987 15.1667C12.1806 15.1667 15.1654 12.1819 15.1654 8.50004C15.1654 4.81814 12.1806 1.83337 8.4987 1.83337C4.8168 1.83337 1.83203 4.81814 1.83203 8.50004C1.83203 12.1819 4.8168 15.1667 8.4987 15.1667Z" stroke="${stroke}" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.5 11.1667V8.5" stroke="${stroke}" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.5 5.83337H8.50667" stroke="${stroke}" stroke-linecap="round" stroke-linejoin="round"/>
  `;
};

export default {
	W: 17,
	H: 17,
	body,
} as _SVGIcon.Icon;
